import SearchPage from './SearchPage';

import styles from './Routes.module.scss';

const App = () => {
  return (
    <div className={styles.app}>
      <SearchPage />
    </div>
  );
};

export default App;
